export default __webpack_public_path__ + "static/media/lomoIcon1Complete.7220c8a5.svg";